/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ApiResponseOfAuthLoginResponse } from '../model';
// @ts-ignore
import { ApiResponseOfAuthTokenResponse } from '../model';
// @ts-ignore
import { AuthLoginBody } from '../model';
// @ts-ignore
import { AuthRefreshBody } from '../model';
/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Refreshes a user\'s `token` in the **Vix CMS** application for authenticating.
         * @param {AuthRefreshBody} authRefreshBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRefreshToken: async (authRefreshBody: AuthRefreshBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authRefreshBody' is not null or undefined
            assertParamExists('getRefreshToken', 'authRefreshBody', authRefreshBody)
            const localVarPath = `/api/v1/auth/refresh-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authRefreshBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authenticates a user in the **Vix CMS** application by assigning a `provider`.
         * @param {string} provider 
         * @param {AuthLoginBody} authLoginBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (provider: string, authLoginBody: AuthLoginBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('login', 'provider', provider)
            // verify required parameter 'authLoginBody' is not null or undefined
            assertParamExists('login', 'authLoginBody', authLoginBody)
            const localVarPath = `/api/v1/auth/login/{provider}`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authLoginBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * Refreshes a user\'s `token` in the **Vix CMS** application for authenticating.
         * @param {AuthRefreshBody} authRefreshBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRefreshToken(authRefreshBody: AuthRefreshBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfAuthTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRefreshToken(authRefreshBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Authenticates a user in the **Vix CMS** application by assigning a `provider`.
         * @param {string} provider 
         * @param {AuthLoginBody} authLoginBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(provider: string, authLoginBody: AuthLoginBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfAuthLoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(provider, authLoginBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * Refreshes a user\'s `token` in the **Vix CMS** application for authenticating.
         * @param {AuthRefreshBody} authRefreshBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRefreshToken(authRefreshBody: AuthRefreshBody, options?: any): AxiosPromise<ApiResponseOfAuthTokenResponse> {
            return localVarFp.getRefreshToken(authRefreshBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Authenticates a user in the **Vix CMS** application by assigning a `provider`.
         * @param {string} provider 
         * @param {AuthLoginBody} authLoginBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(provider: string, authLoginBody: AuthLoginBody, options?: any): AxiosPromise<ApiResponseOfAuthLoginResponse> {
            return localVarFp.login(provider, authLoginBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - interface
 * @export
 * @interface AuthApi
 */
export interface AuthApiInterface {
    /**
     * Refreshes a user\'s `token` in the **Vix CMS** application for authenticating.
     * @param {AuthRefreshBody} authRefreshBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    getRefreshToken(authRefreshBody: AuthRefreshBody, options?: any): AxiosPromise<ApiResponseOfAuthTokenResponse>;

    /**
     * Authenticates a user in the **Vix CMS** application by assigning a `provider`.
     * @param {string} provider 
     * @param {AuthLoginBody} authLoginBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    login(provider: string, authLoginBody: AuthLoginBody, options?: any): AxiosPromise<ApiResponseOfAuthLoginResponse>;

}

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI implements AuthApiInterface {
    /**
     * Refreshes a user\'s `token` in the **Vix CMS** application for authenticating.
     * @param {AuthRefreshBody} authRefreshBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public getRefreshToken(authRefreshBody: AuthRefreshBody, options?: any) {
        return AuthApiFp(this.configuration).getRefreshToken(authRefreshBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Authenticates a user in the **Vix CMS** application by assigning a `provider`.
     * @param {string} provider 
     * @param {AuthLoginBody} authLoginBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public login(provider: string, authLoginBody: AuthLoginBody, options?: any) {
        return AuthApiFp(this.configuration).login(provider, authLoginBody, options).then((request) => request(this.axios, this.basePath));
    }
}
